module.exports = __webpack_public_path__ + "static/media/add-icon-blue.cc6ef183.svg";